import { StyleSheet } from 'react-native';

export const createCommonStyles = (colors) =>
    StyleSheet.create({
        container: {
            flex: 1,
        },
        cardstyle: {
            backgroundColor: colors.background_white,
            borderWidth: 1,
            borderColor: colors.border_card,
            borderRadius: 14,
            shadowColor: 'rgba(92, 143, 26, 1)',
            shadowOffset: { width: 0, height: 5 },
            shadowOpacity: 0.08,
            shadowRadius: 12,
            elevation: 5,
            overflow: 'hidden',
            marginBottom: 16,
        },
        cardstyle_transparent: {
            backgroundColor: 'transparent',
            borderWidth: 1,
            borderColor: colors.border_card,
            borderRadius: 14,
            shadowColor: 'rgba(92, 143, 26, 1)',
            shadowOffset: { width: 0, height: 5 },
            shadowOpacity: 0.08,
            shadowRadius: 12,
            elevation: 5,
            overflow: 'hidden',
            marginBottom: 16,
        },
        divider: {
            borderBottomColor: colors.text_primary,
            marginVertical: 5,
            borderBottomWidth: StyleSheet.hairlineWidth,
        },
        verticalDivider: {
            backgroundColor: colors.text_primary,
            height: '100%',
            width: 1,
        },
        titleButtonRow: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 12,
        },
        listTitle: {
            flex: 1,
            marginVertical: 10,

        },
        flexRow: {
            margin: 5,
            flexDirection: 'row',
            flex: 1,
        }
    });